import { render, staticRenderFns } from "./advertList.vue?vue&type=template&id=cb23dc16&scoped=true&"
import script from "./advertList.vue?vue&type=script&lang=js&"
export * from "./advertList.vue?vue&type=script&lang=js&"
import style0 from "./advertList.vue?vue&type=style&index=0&id=cb23dc16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb23dc16",
  null
  
)

export default component.exports